import styled from 'styled-components';

export const CrossedOutPrice = styled.del`
  color: ${props => props.theme.colors.capsuleRed80} !important;
`;

export const NewPrice = styled.span`
  font-size: ${props => props.theme.fontSizes.headerThree};
  font-weight: bold;
`;

export const Price = styled.span``;

export const ImageTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 50%;
  margin-right: ${props => props.theme.space['8.0']};
  ${props => props.theme.mediaQueries.smallDown} {
    max-width: 100%;
    margin-right: 0;
  }

  img {
    ${props => props.theme.mediaQueries.smallDown} {
      display: none;
    }
  }
`;
